module.exports = __webpack_public_path__ + "media/images/pillar_amazon-826f1a9bddb5294a2128e547b3346638.jpg";